import { ColumnDef } from '@tanstack/react-table';

export interface FullCycleRow {
  date: string;
  ticker: string;
  pct_change: number;
  sp500_change: number;
  sector: string;
  company_name: string;
  ranking: number;
  inactive_date: string | null;
  is_new: boolean;
  is_old: boolean;
}

export const columns: ColumnDef<FullCycleRow>[] = [
  {
    header: 'Active Date',
    accessorKey: 'date',
  },
  {
    header: 'Ticker',
    accessorKey: 'ticker',
  },
  {
    header: '% Change',
    accessorKey: 'pct_change',
  },
  {
    header: 'S&P 500 % Chg',
    accessorKey: 'sp500_change',
  },
  {
    header: 'Sector',
    accessorKey: 'sector',
  },
  {
    header: 'Company',
    accessorKey: 'company_name',
  },
  {
    header: 'Rank',
    accessorKey: 'ranking',
    sortingFn: (rowA, rowB, columnId) => {
      const a = rowA.getValue<number>(columnId);
      const b = rowB.getValue<number>(columnId);
      const aIsInt = Number.isInteger(a);
      const bIsInt = Number.isInteger(b);

      if (aIsInt && bIsInt) {
        return a < b ? -1 : a > b ? 1 : 0;
      }
      // Push non-integer ranks to the end
      if (!aIsInt && bIsInt) return 1;
      if (aIsInt && !bIsInt) return -1;
      return 0;
    },
  },
  {
    header: 'Closed',
    accessorKey: 'inactive_date',
  },
  {
    header: 'Is New',
    accessorKey: 'is_new',
  },
  {
    header: 'Is Old',
    accessorKey: 'is_old',
  },
];
